export default __webpack_public_path__ + "static/media/RO.00bea312.svg";